import Backbone from "backbone";
import componentWizards from "app/components/appwizard/component-wizards/component-wizards";
import componentService from "../../../core/services/componentService/component-service";
import templateInfoService from "../../../core/services/componentService/topology-info-service";

function generateSteps(templateID) {
    if (!templateID) return [];

    const { source, target } = templateInfoService.getTopologyInfoFromURL(templateID);
    return target === "Striim" ? [source] : [source, target];
}

export default function(options) {
    const stepsCollection = new Backbone.Collection();
    const steps = generateSteps(options.templateID);

    let counter = 1;
    steps.forEach((step, id) => {
        // In case of IL-CDC, Remove the string "Initial Load" from the step title
        let formattedHumanReadableName = componentService.getHumanReadableName(step);
        if (options.templateID.includes("automated-ILCDC"))
            formattedHumanReadableName = formattedHumanReadableName.replace(/\b(?:Initial Load|CDC)/g, "");
        stepsCollection.add({
            title: formattedHumanReadableName,
            wizard_location: step,
            step_tooltip_title: formattedHumanReadableName,
            step_tooltip_text: formattedHumanReadableName,
            counter: counter++,
            current: id === options.componentID,
            isAutomatedILCDC: options.templateID.includes("automated-ILCDC")
        });
    });

    // console.log(stepsCollection, options);

    const component_wizard = stepsCollection.at(options.componentID);
    const component_wizard_id = component_wizard.get("wizard_location");
    const predefinedValues = {
        name: options.predefinedName
    };
    let componentWizardView = componentWizards.getComponentWizardView(
        component_wizard_id,
        options.appName,
        options.templateID,
        options.params,
        steps[0],
        predefinedValues,
        options.stepName,
        options.prefillWizardData
    );

    return {
        view: componentWizardView,
        steps: stepsCollection
    };
}
